module.exports = __webpack_public_path__ + "851d60748c878027e7a52c42c441b138.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/12.jpg
 ** module id = 211
 ** module chunks = 0
 **/